import useTrainingCatalog from './useTrainingCatalog';

export default useTrainingCatalog;
